export const externalPartyIdentifiers = {
  DBB: "DBB",
  TEMUR: "TEMUR",
  INTERNAL: "INTERNAL"
}